<!-- src/App.vue -->
<template>
  <div>
    <!-- Main application layout -->
    <div v-if="authStore.user" class="bg-white text-gray-900 flex">
      <Sidebar />
      <div class="flex-1">
        <TopNavigation />
        <!-- Remove the ContentBlockList component from here -->
        <!-- Router View for nested routes -->
        <router-view />
        <!-- Modals -->
        <AddCompetitorModal v-if="mainStore.showAddCompetitorModal" />
        <FullViewModal
          v-if="mainStore.showFullViewModal"
          :imageSrc="mainStore.fullViewImageSrc"
        />
      </div>
    </div>
    <!-- Unauthenticated users see the router view (login/register pages) -->
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import { watch } from 'vue';                // ① neu
import Sidebar           from '@/components/AppSidebar.vue';
import TopNavigation     from '@/components/TopNavigation.vue';
import AddCompetitorModal from '@/components/AddCompetitorModal.vue';
import FullViewModal     from '@/components/FullViewModal.vue';
import { useMainStore }  from '@/stores/useMainStore';
import { useAuthStore }  from '@/stores/useAuthStore';

export default {
  components: {
    Sidebar,
    TopNavigation,
    AddCompetitorModal,
    FullViewModal,
  },
  setup() {
    const mainStore = useMainStore();       // ②
    const authStore = useAuthStore();       // ③

    // ④ Reaktiv neu laden, sobald ein User da ist
        watch(
      () => authStore.user,
      async (user) => {
        // only reload on the very first sign-in
        if (user && !mainStore._hasBootstrapped) {
          await mainStore.reloadData();
          mainStore._hasBootstrapped = true;
        }
      },
      { immediate: true }
    );

    return { mainStore, authStore };
  },
};
</script>

